import { render, staticRenderFns } from "./OrderTypeSelect.vue?vue&type=template&id=12c34abe&scoped=true&"
import script from "./OrderTypeSelect.vue?vue&type=script&lang=js&"
export * from "./OrderTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypeSelect.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderTypeSelect.vue?vue&type=style&index=1&id=12c34abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c34abe",
  null
  
)

export default component.exports